
<div>
    <div class="row-header pl-0 col-6 align-content-start"><img src="../.../../../../../assets/img/jetnet-logo.png" style="max-width:130px;" /></div>
    <mat-form-field>
        <input (change)="tailNumberSearchChanged($event)" (keydown.enter)="tailNumberSearchChanged($event)"
               matInput id="tailNumber" />
        <span matSuffix><i class="fa fa-search" (click)="tailNumberSearchChanged($event)"></i></span>
    </mat-form-field>
</div>
